import { AcStatusTimingsType } from './../../../../../models/acstatus/ac-status.type';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthStateService } from '../../../../../services/auth-state.service';
import { DataService } from './../../../../../services/data.service';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { SlotModel } from 'projects/runner/src/app/models/slot.model';

@Component({
  selector: 'app-conference-controls',
  templateUrl: './conference-controls.component.html',
  styleUrls: ['./conference-controls.component.scss']
})
export class ConferenceControlsComponent implements OnInit, OnDestroy {

  private hash = 'conference';
  private sendingSubscription: Subscription = null;
  private slot: SlotModel;
  public ac: AcModel = null;
  private acSubscription: Subscription = null;
  public sending = false;

  constructor(
    private data: DataService,
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
    this.sendingSubscription = this.data.sendingTiming$.subscribe((sending: boolean) => {
      this.sending = sending;
    });
    this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        this.ac = ac;
        this.slot = this.ac?.getConference();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sendingSubscription !== null) {
      this.sendingSubscription.unsubscribe();
      this.sendingSubscription = null;
    }
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
      this.acSubscription = null;
    }
  }

  public start(): void {
    this.sendTiming(this.slot?.startSlot(this.hash));
  }

  public pause(): void {
    this.sendTiming(this.slot?.pauseSlot(this.hash));
  }

  public resume(): void {
    this.sendTiming(this.slot?.resumeSlot(this.hash));
  }

  public finish(): void {
    this.sendTiming(this.slot?.finishSlot(this.hash));
  }

  public reset(): void {
    this.sendTiming(null);
  }

  public isStartable(): boolean {
    return this.slot?.isStartable(this.hash);
  }

  public isPauseable(): boolean {
    return this.slot?.isPauseable(this.hash);
  }

  public isResumeable(): boolean {
    return this.slot?.isResumeable(this.hash);
  }

  public isFinishable(): boolean {
    return this.slot?.isFinishable(this.hash);
  }

  public isResetable(): boolean {
    return this.slot?.isResetable(this.hash);
  }

  private sendTiming(timing: AcStatusTimingsType): void {
    this.data.setTiming(this.slot, this.hash, timing);
  }
}
